"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var PreviewCompressionConfig_1 = require("@CommonFrontendBackend/PdfPreviewConfig/PreviewCompressionConfig");
var PreviewConfig_1 = require("@CommonFrontendBackend/PdfPreviewConfig/PreviewConfig");
var PreviewExportConfig_1 = require("@CommonFrontendBackend/PdfPreviewConfig/PreviewExportConfig");
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PdfPreview = (function (_super) {
    __extends(PdfPreview, _super);
    function PdfPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.showPreviewIframe = false;
        _this.iframeKey = 1;
        _this.oneTimeToken = "";
        _this.iframeHeight = 0;
        _this.handlePreviewFormatterMessage = function (event) {
            var _a;
            var data = event === null || event === void 0 ? void 0 : event.data;
            if ((data === null || data === void 0 ? void 0 : data.status) === PreviewConfig_1.PDF_PREVIEW_DONE && !!(data === null || data === void 0 ? void 0 : data.contentHeight)) {
                _this.iframeHeight = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.contentHeight;
                _this.showPreviewIframe = true;
            }
        };
        _this.handleLayoutOptionChange = function (orientation) {
            if (_this.selectedSettings.orientation === orientation) {
                return;
            }
            if (!(0, PreviewConfig_1.isOrientationOption)(orientation)) {
                return;
            }
            _this.selectedSettings.orientation = orientation;
            _this.updatePdfConfigs();
        };
        _this.handlePageSizeChange = function (selectedPageSize) {
            if (_this.selectedSettings.pageSize === selectedPageSize) {
                return;
            }
            if (!(0, PreviewConfig_1.isPageSizeOption)(selectedPageSize)) {
                return;
            }
            _this.selectedSettings.pageSize = selectedPageSize;
            _this.updatePdfConfigs();
        };
        _this.updatePdfConfigs = function () {
            _this.updateOneTimeToken();
            _this.reloadIframe();
            _this.saveAsDefaultPreviewSettings();
        };
        _this.reloadIframe = function () {
            _this.iframeHeight = PreviewConfig_1.paperSizeOptions[_this.selectedSettings.pageSize][_this.selectedSettings.orientation].height;
            _this.iframeKey = _this.iframeKey + 1;
            _this.showPreviewIframe = false;
        };
        _this.updateOneTimeToken = function () { return __awaiter(_this, void 0, Promise, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.getOneTimeToken()];
                    case 1:
                        token = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.oneTimeToken = token;
                        });
                        return [2];
                }
            });
        }); };
        _this.addExportOptionQuery = function (baseUrl) {
            var _a = _this.selectedSettings, includeEmbeddedContent = _a.includeEmbeddedContent, includePageNumbers = _a.includePageNumbers, includeVideos = _a.includeVideos, useCompactLayout = _a.useCompactLayout;
            var updatedUrl = baseUrl;
            if (!includeEmbeddedContent) {
                updatedUrl = "".concat(updatedUrl, "&").concat(PreviewExportConfig_1.REMOVE_EMBEDDED_CONTENT, "=true");
            }
            if (!includePageNumbers) {
                updatedUrl = "".concat(updatedUrl, "&").concat(PreviewExportConfig_1.REMOVE_PAGE_NUMBERS, "=true");
            }
            if (!includeVideos) {
                updatedUrl = "".concat(updatedUrl, "&").concat(PreviewExportConfig_1.REMOVE_VIDEOS, "=true");
            }
            if (useCompactLayout) {
                updatedUrl = "".concat(updatedUrl, "&").concat(PreviewExportConfig_1.USE_COMPACT_LAYOUT, "=true");
            }
            return updatedUrl;
        };
        _this.handleCompressionChange = function (selectedCompression) {
            _this.selectedSettings.compression = selectedCompression;
            _this.saveAsDefaultPreviewSettings();
        };
        _this.handleLayoutChange = function (useCompactLayout) {
            if (_this.selectedSettings.useCompactLayout === useCompactLayout) {
                return;
            }
            _this.selectedSettings.useCompactLayout = useCompactLayout;
            _this.updatePdfConfigs();
        };
        _this.toggleExportOption = function (optionKey) {
            var currentExportOptionValue = _this.selectedSettings[optionKey];
            _this.selectedSettings[optionKey] = !currentExportOptionValue;
            _this.updatePdfConfigs();
        };
        _this.saveAsDefaultPreviewSettings = function () {
            _this.props.updateDefaultPreviewSettings(_this.selectedSettings);
        };
        _this.onKeydown = function (e) {
            if (e.key === "Escape") {
                e.preventDefault();
                _this.props.closePreview();
            }
        };
        _this.selectedSettings = __assign({}, _this.props.defaultPreviewSettings);
        _this.iframeHeight = PreviewConfig_1.paperSizeOptions[_this.selectedSettings.pageSize][_this.selectedSettings.orientation].height;
        return _this;
    }
    PdfPreview.prototype.componentDidMount = function () {
        window.addEventListener("message", this.handlePreviewFormatterMessage);
        this.props.trackPdfPreviewAction();
        this.updateOneTimeToken();
        document.addEventListener("keydown", this.onKeydown);
    };
    PdfPreview.prototype.componentWillUnmount = function () {
        window.removeEventListener("message", this.handlePreviewFormatterMessage);
        window.removeEventListener("keydown", this.onKeydown);
    };
    PdfPreview.prototype.render = function () {
        var _this = this;
        var _a = this, showPreviewIframe = _a.showPreviewIframe, iframeKey = _a.iframeKey, selectedSettings = _a.selectedSettings;
        var includeEmbeddedContent = selectedSettings.includeEmbeddedContent, includePageNumbers = selectedSettings.includePageNumbers, includeVideos = selectedSettings.includeVideos, useCompactLayout = selectedSettings.useCompactLayout, orientation = selectedSettings.orientation, compression = selectedSettings.compression, pageSize = selectedSettings.pageSize;
        var pageSizeConfig = PreviewConfig_1.paperSizeOptions[pageSize];
        return (react_1.default.createElement("div", { className: "pdf-preview" },
            react_1.default.createElement("div", { className: "pdf-preview__setting-container" },
                react_1.default.createElement("div", { className: "pdf-preview__setting-container-main" },
                    react_1.default.createElement("h2", { className: "pdf-preview__option-label" }, "PDF page options"),
                    react_1.default.createElement("div", { className: "pdf-preview__options" },
                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Page size", options: PreviewConfig_1.paperSizeControlOptions, selectedValue: pageSize, onClickHandler: this.handlePageSizeChange })),
                    react_1.default.createElement("div", { className: "pdf-preview__options" },
                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Page orientation", options: PreviewConfig_1.pageOrientationOptions, selectedValue: orientation, onClickHandler: this.handleLayoutOptionChange })),
                    react_1.default.createElement("h2", { className: "pdf-preview__option-label" }, "Appearance"),
                    react_1.default.createElement("div", { className: "pdf-preview__options" },
                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Image quality", tooltipSize: kaleidoscope_1.TooltipSize.Large, options: PreviewCompressionConfig_1.compressionOptions, selectedValue: compression, onClickHandler: this.handleCompressionChange })),
                    !this.props.disableLayout && (react_1.default.createElement("div", { className: "pdf-preview__options" },
                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "layout", tooltipSize: kaleidoscope_1.TooltipSize.Large, options: PreviewConfig_1.pageLayoutOptions, selectedValue: useCompactLayout, onClickHandler: this.handleLayoutChange }))),
                    react_1.default.createElement("div", { className: "pdf-preview__exports-options-container" },
                        react_1.default.createElement("h2", { className: "pdf-preview__option-label" }, "Include in export"),
                        react_1.default.createElement("div", { className: "pdf-preview__exports-options" },
                            react_1.default.createElement(kaleidoscope_1.Toggle, { value: includePageNumbers, label: "Page numbers", onChange: function () { return _this.toggleExportOption(PreviewConfig_1.PdfPreviewOption.INCLUDE_PAGE_NUMBERS); } }),
                            react_1.default.createElement(kaleidoscope_1.Toggle, { value: includeEmbeddedContent, label: "Embed content", onChange: function () { return _this.toggleExportOption(PreviewConfig_1.PdfPreviewOption.INCLUDE_EMBED); } }),
                            react_1.default.createElement(kaleidoscope_1.Toggle, { value: includeVideos, label: "Videos", onChange: function () { return _this.toggleExportOption(PreviewConfig_1.PdfPreviewOption.INCLUDE_VIDEOS); } })))),
                react_1.default.createElement("footer", { className: "pdf-preview__download-section pdf-preview__setting-container-footer" },
                    react_1.default.createElement(kaleidoscope_1.CopyInput, { labelHidden: true, label: "PDF download link", value: "".concat(this.pdfDownloadUrl, "&origin=").concat(PreviewConfig_1.PdfDownloadOrigin.Url) }),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "pdf-preview__download-button", href: function () { return "".concat(_this.pdfDownloadUrl, "&origin=").concat(PreviewConfig_1.PdfDownloadOrigin.Download); } }, "Download PDF"))),
            react_1.default.createElement("div", { className: "pdf-preview__preview-container" },
                !showPreviewIframe && (react_1.default.createElement("div", { className: "pdf-preview__spinner-container" },
                    react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true, size: kaleidoscope_1.SpinnerSize.Large, message: "Loading Preview" }))),
                react_1.default.createElement("div", { className: (0, classnames_1.default)({
                        "pdf-preview__preview-iframe-container": true,
                        "pdf-preview__preview-iframe-container--portrait": orientation === PreviewConfig_1.Orientation.Portrait,
                        "pdf-preview__preview-iframe-container--landscape": orientation === PreviewConfig_1.Orientation.Landscape,
                    }) },
                    react_1.default.createElement("iframe", { className: (0, classnames_1.default)({
                            "pdf-preview__preview-iframe": true,
                            "pdf-preview__preview-iframe--show": showPreviewIframe,
                        }), src: this.previewUrl, key: iframeKey, width: pageSizeConfig[orientation].width, height: this.iframeHeight, allowFullScreen: true })))));
    };
    Object.defineProperty(PdfPreview.prototype, "pdfDownloadUrl", {
        get: function () {
            var _a = this.selectedSettings, orientation = _a.orientation, compression = _a.compression, pageSize = _a.pageSize;
            var baseUrl = "".concat(this.props.pdfUrl, "?orientation=").concat(orientation, "&compressionSetting=").concat(compression, "&pageSize=").concat(pageSize);
            return this.addExportOptionQuery(baseUrl);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PdfPreview.prototype, "previewUrl", {
        get: function () {
            var baseUrl = "".concat(this.props.publicLink, "&preview=1&one_time=").concat(this.oneTimeToken, "&orientation=").concat(this.selectedSettings.orientation, "&pageSize=").concat(this.selectedSettings.pageSize);
            return this.addExportOptionQuery(baseUrl);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    PdfPreview.defaultProps = {
        disableLayout: false,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "showPreviewIframe", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "iframeKey", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "oneTimeToken", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof PreviewConfig_1.IPreviewSetting !== "undefined" && PreviewConfig_1.IPreviewSetting) === "function" ? _a : Object)
    ], PdfPreview.prototype, "selectedSettings", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Number)
    ], PdfPreview.prototype, "iframeHeight", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PdfPreview.prototype, "pdfDownloadUrl", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "handlePreviewFormatterMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "handleLayoutOptionChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "handlePageSizeChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "reloadIframe", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PdfPreview.prototype, "previewUrl", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "handleCompressionChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "handleLayoutChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PdfPreview.prototype, "toggleExportOption", void 0);
    PdfPreview = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PdfPreview);
    return PdfPreview;
}(react_1.default.Component));
exports.default = PdfPreview;
